<div class="boxWhite" #boxWhiteRef>
  <h4>BUS: {{getMovil().numeroInterno}}</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <header class="bgLightGray mb-4">
    <div class="row">
      <div class="col-6">
        <h6 class="clBlack">Patente</h6>
        <p class="clGray">{{getMovil().patente}}</p>
      </div>
      <div class="col-6">
        <h6 class="clBlack">TIPO DE BUS</h6>
        <p class="clGray">{{getMovil().tipoMovil.codigo}}</p>
      </div>
      <div class="col-6">
        <h6 class="clBlack">N° asientos</h6>
        <p class="clGray fw-medium">{{getMovil().tipoMovil.asientos}}</p>
      </div>
      <div *ngIf="getMovil().tipoMovil.combustible === 'ELECTRICO'" class="col-6">
        <h6 class="clBlack">CARGA ELECTRICA</h6>
        <p class="clGray">{{getEnergiaDisponible()}}</p>
      </div>
      <div *ngIf="getMovil().tipoMovil.combustible === 'DIESEL'" class="col-6">
        <h6 class="clBlack">NIVEL COMBUSTIBLE</h6>
        <p class="clGray">{{getEnergiaDisponible()}}</p>
      </div>
      <div class="col-6">
        <h6 class="clBlack">ESTADO ACTUAL</h6>
        <p class="clGray">{{getMovil().estado}}</p>
      </div>
      <div class="col-6">
        <h6 class="clBlack">TIEMPO ASIGNADO</h6>
        <p class="clGray">{{getDuracionAsignado}}</p>
      </div>
      <div class="col-6">
        <h6 class="clBlack">TIEMPO RESTANTE</h6>
        <p class="fw-medium" [ngClass]="isTiempoCritico">{{getTiempoRestanteHHmm}}</p>
      </div>
      <div class="col-6">
        <h6 class="clBlack">TIEMPO TRANSCURRIDO</h6>
        <p class="clGray fw-medium">{{getTiempoEnEstadoHHmm}}</p>
      </div>
      <div class="col-6" *ngIf="getSucursalOrigen">
        <h6 class="clBlack">Origen</h6>
        <p class="clGray fw-medium">{{getSucursalOrigen}}</p>
      </div>
      <div class="col-6" *ngIf="getSucursalDestino">
        <h6 class="clBlack">Destino</h6>
        <p class="clGray fw-medium">{{getSucursalDestino}}</p>
      </div>

    </div>
  </header>

  <div *ngIf="getMovil().estado !== 'ASIGNADO' && getMovil().estado !== 'EN_CURSO'" class="contModal">

    <tabset class="tabBus" #staticTabs>
      <tab heading="CAMBIAR ESTADO" (selectTab)="onTabChanged($event)">

        <div class="radios">
          <!-- Contenedor tipo tabla para dividir en 2 columnas -->
          <table style="width: 100%; border-spacing: 10px 0;">
            <tr>
              <td style="width: 50%;">
                <label class="itemRadio">
                  <input type="radio" name="radioBus" value="DISPONIBLE" [(ngModel)]="estadoSeleccionado"
                    [disabled]="!puedeSeleccionarEstado(EstadoBus.DISPONIBLE)">
                  <span class="boxRadio">DISPONIBLE</span>
                </label>
              </td>
              <td style="width: 50%;">
                <label class="itemRadio">
                  <input type="radio" name="radioBus" value="EN_LAVADO" [(ngModel)]="estadoSeleccionado"
                    [disabled]="!puedeSeleccionarEstado(EstadoBus.EN_LAVADO)">
                  <span class="boxRadio">EN LAVADO</span>
                </label>
              </td>
            </tr>
            <tr>
              <td style="width: 50%;">
                <label class="itemRadio">
                  <input type="radio" name="radioBus" value="EN_CARGA" [(ngModel)]="estadoSeleccionado"
                    [disabled]="!puedeSeleccionarEstado(EstadoBus.EN_CARGA)">
                  <span class="boxRadio">EN CARGA</span>
                </label>
              </td>
              <td>
                <label class="itemRadio">
                  <input type="radio" name="radioBus" value="EN_TALLER" [(ngModel)]="estadoSeleccionado"
                    [disabled]="!puedeSeleccionarEstado(EstadoBus.EN_TALLER)">
                  <span class="boxRadio">EN TALLER</span>
                </label>
              </td>
            </tr>
          </table>
        </div>

        <div class="mb-4 mt-4">
          <input #inputTiempo type="search" class="form-control" placeholder="Tiempo en formato HH:mm"
            [(ngModel)]="tiempo" [disabled]="(estadoSeleccionado === 'DISPONIBLE' && tipoDeActualizacion === Opciones.CAMBIAR_ESTADO)
          || getMovil().estado === 'ASIGNADO' || getMovil().estado === 'EN_CURSO'" (input)="formatearTiempo($event)">
        </div>
      </tab>

      <tab *ngIf="tienePermisoExtenderTiempo()" heading="EXTENDER TIEMPO" (selectTab)="onTabChanged($event)">
        <div class="radios">

        </div>
        <div class="mb-4 mt-4">
          <input type="search" class="form-control" placeholder="Tiempo en formato HH:mm"
            [disabled]="getMovil().estado === 'DISPONIBLE'" [(ngModel)]="tiempo" (input)="formatearTiempo($event)">
        </div>
      </tab>

    </tabset>

  </div>

  <h4 *ngIf="getMovil().estado === 'ASIGNADO' || getMovil().estado === 'EN_CURSO'">
    No se puede extender tiempo ni cambiar estado de un bus que se encuentre <b>Asignado</b> o <b>En Curso</b>
  </h4>

  <div class="footModal">
    <button *ngIf="getMovil().estado !== 'ASIGNADO' && getMovil().estado !== 'EN_CURSO' && tienePermisoParaEnviar()" class="btn btnRed w-100"
      [disabled]="enviando" (click)="updateMovil()">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {{textoBoton}}
    </button>
    <button *ngIf="getMovil().estado === 'ASIGNADO' || getMovil().estado === 'EN_CURSO'" class="btn btnBlue w-100"
      (click)="this.close()">
      CERRAR
    </button>
  </div>

</div>